"use client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import styles from "../css/landing.module.css";
import Modal from "../../../components/login-modal";

const Landing = () => {
  const navigate = useNavigate();
  const images = [
   // "/images/j1.jpeg",
  "/images/pexels-karola-g-7195369.jpg",
  "/images/pexels-tima-miroshnichenko-5452300.jpg",
    "/images/pharmacy3.jpg",
    "/images/crop-black-doctor-with-arms-crossed.jpg",
    "/images/pexels-ivan-s-4989137.jpg",
    "/images/pharmacy4.jpg",
    "/images/pharmacy5.jpg",
    "/images/pharmacy6.jpg",
    "/images/pharmacy7.jpg",
    "/images/pharmacy8.jpg",
    "/images/pexels-rdne-8581035.jpg",
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalForm, setModalForm] = useState("login");
  const [current, setCurrent] = useState(0);
  

  useEffect(() => {
    if (!images.length) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleLoginClick = () => {
    if (isModalOpen && modalForm !== "login") {
      setIsModalOpen(false);
      setTimeout(() => {
        setModalForm("login");
        setIsModalOpen(true);
      }, 50);
    } else {
      setModalForm("login");
      setIsModalOpen(true);
    }
  };

  const handleApplyClick = () => {
    navigate("/credits");
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openFrontShop = () => navigate("/frontshop/login");

  return (
    <div className={styles.landing}>
      {/* Background slideshow */}
      <div className={styles.slideshow}>
        {images.map((src, i) => (
          <div
            key={src}
            className={`${styles.slide} ${i === current ? styles.active : ""}`}
            style={{ backgroundImage: `url(${src})` }}
            aria-hidden={i !== current}
          />
        ))}
      </div>

      <div className={styles.overlay}></div>

      <div className={styles.topActions}>
        {/* <Button
          onClick={handleApplyClick}
          className={styles.applyButton}
          variant="approve"
          type="button"
        >
          Apply
        </Button> */}
        <Button
          onClick={handleLoginClick}
          className={styles.loginButton}
          variant="primary"
          type="button"
        >
          Login
        </Button>
      </div>

      

      <div className={styles.content}>
        <div className={styles.leftSection}>
          <h1 className={styles.title}>MediIntel</h1>
          <p className={styles.tagline}>
          Pharmacy Management System
          </p>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.cards}>
            <div className={styles.card}>
              <span className={styles.number}>3+</span>
              <p>Active Pharmacies</p>
            </div>
            <div className={styles.card}>
              <span className={styles.number}>30+</span>
              <p>Daily Deliveries</p>
            </div>
            <div className={styles.card}>
              <span className={styles.number}>98%</span>
              <p>Patient Satisfaction</p>
            </div>
            <div className={styles.card}>
              <span className={styles.number}>99.9%</span>
              <p>System Uptime</p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        key={modalForm}
        isOpen={isModalOpen}
        onClose={closeModal}
        initialForm={modalForm}
        onOpenFrontShop={openFrontShop}
      />
    </div>
  );
};

export default Landing;
